const replaceVariableInString = (configString: string, variableName: string, variable: number) => {
    return configString.replace(`{$${variableName}}`, `${variable}`.replace('.', ','));
};

export default replaceVariableInString;
